<template>
  <div ref="table" class="table">
    <!--表头-->
    <div class="table-header text">
      <div class="column-1">收费排行榜</div>
      <div class="column-2">项目名称</div>
      <div class="column-3">收费金额</div>
    </div>
    <div class="gap"></div>
    <!--表格数据-->
    <div v-if="tableData && tableData.length" class="table-tr" ref="tableTr" @mouseenter="pause" @mouseleave="resume">
      <div v-for="(item, index) in tableData" :key="index" class="table-row row">
        <div class="column-1">
          <div class="rank" :class="{ firstly: item.rank === 1, second: item.rank === 2, third: item.rank === 3 }">{{ item.rank }}</div>
        </div>
        <div class="column-2 text">{{ item.communityName || '-' }}</div>
        <div class="column-3">
          <span class="amount color">{{ evaluatorNum(item.realAmount) }}</span>
          <span class="unit color">{{ evaluatorUnit(item.realAmount, '元') }}</span>
        </div>
      </div>
    </div>
    <div v-else class="empty">
      <img src="../../assets/img/empty.png" alt="" />
    </div>
  </div>
</template>

<script>
import { evaluatorNum, evaluatorUnit } from '../../assets/js/dataUtil'
export default {
  props: {
    data: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      evaluatorNum,
      evaluatorUnit,
      animationId: null,
      tableData: [],
      isPaused: false,
      timer: null,
    }
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val && val.length) {
          this.tableData = this.data.map((item, index) => {
            return {
              rank: index + 1,
              ...item,
            }
          })
          this.$nextTick(() => {
            this.animation()
          })
        }
      },
    },
  },
  destroyed() {
    clearTimeout(this.timer)
    cancelAnimationFrame(this.animationId) // 取消当前的动画帧请求
  },
  methods: {
    pause() {
      clearTimeout(this.timer)
      cancelAnimationFrame(this.animationId) // 取消当前的动画帧请求
      this.animationId = null // 清空动画帧请求的ID
      this.isPaused = true // 标记动画为暂停状态
    },

    resume() {
      if (this.isPaused) {
        // 当动画处于暂停状态时
        this.animation() // 重新调用动画函数
        this.isPaused = false // 将动画状态设置为播放
      }
    },

    animation() {
      let container = this.$refs.table

      this.animationId = requestAnimationFrame(() => {
        container.scrollTop += 1 // 每次滚动 1px

        if (Math.floor(container.scrollHeight - container.scrollTop) <= container.clientHeight) {
          container.scrollTop = 0 // 回到顶部
        }
        if (this.timer) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.animationId = requestAnimationFrame(this.animation)
        }, 100)
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '../../assets/css/charts.scss';
.table::-webkit-scrollbar {
  /* WebKit browsers (Chrome, Safari) */
  display: none;
}
.table {
  position: relative;
  width: vw(770);
  height: vh(252);
  overflow: hidden;
  margin: vh(24) 0;
  .empty {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: vh(35);
    img {
      width: vw(187);
      height: vh(176);
    }
  }
  .row {
    display: flex;
    align-items: center;
    width: vw(770);
    height: vh(36);
  }
  .rank {
    font-size: rem(17);
    font-weight: 500;
    color: #b3cdf9;
    font-style: oblique;
  }
  .row:nth-child(2n) {
    background: rgba(6, 41, 106, 0.56);
  }
  .firstly {
    color: #fd8031;
    position: relative;
  }
  .firstly::after {
    content: '';
    width: vw(20);
    height: vh(10);
    position: absolute;
    bottom: 0;
    left: vw(-4);
    filter: blur(2px);
    background: linear-gradient(89deg, rgba(181, 108, 62, 0) 0%, rgba(181, 108, 62, 0.67) 49%, rgba(181, 108, 62, 0) 99%);
  }
  .second {
    color: #16d8ff;
    position: relative;
  }
  .second::after {
    content: '';
    width: vw(20);
    height: vh(10);
    position: absolute;
    bottom: 0;
    left: vw(-4);
    filter: blur(2px);
    background: linear-gradient(89deg, rgba(59, 185, 252, 0) 0%, rgba(59, 185, 252, 0.67) 49%, rgba(59, 185, 252, 0) 99%);
  }
  .third {
    position: relative;
    color: #f7cd6c;
  }
  .third::after {
    content: '';
    width: vw(20);
    height: vh(10);
    position: absolute;
    bottom: 0;
    left: vw(-4);
    filter: blur(2px);
    background: linear-gradient(89deg, rgba(241, 187, 63, 0) 0%, rgba(241, 187, 63, 0.67) 49%, rgba(241, 187, 63, 0) 99%);
  }
  .column-1 {
    width: vw(206);
    text-align: left;
    padding-left: vw(28);
    box-sizing: border-box;
  }
  .column-2 {
    width: 53.24%;
    text-align: left;
  }
  .column-3 {
    width: 20%;
    text-align: end;
    padding-right: vw(19);
    box-sizing: border-box;
  }
  .gap {
    width: 100%;
    height: vh(36);
  }
  .table-header {
    display: flex;
    align-items: center;
    width: vw(770);
    height: vh(36);
    position: fixed;
    font-size: rem(14);
    color: #87b2f1;
    background: #062867;
    z-index: 1;
  }
  .text {
    font-size: rem(14);
    color: #aecff3;
  }
  .color {
    background: linear-gradient(180deg, #ffffff 0%, #65bff0 96%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }
  .unit {
    font-size: rem(14);
  }
  .amount {
    font-size: rem(20);
    font-weight: 700;
  }
}
</style>
